import deepEqual from 'fast-deep-equal';
import { MediaItem } from '../media';
import logger from './logger';

/**
 * MediaManager manages updating media items from their models
 */
export default class MediaManager {
  _mediaById = {};

  get media() {
    return Object.values(this._mediaById);
  }

  /**
   * Update media items from their json models
   *
   * Load, update, and destroy media items as needed
   */
  async loadMediaFromModels(mediaModels, pixiApp) {
    this._cleanUp(mediaModels.map((model) => model.id));

    const updatedMedia = await this._createOrUpdate(mediaModels, pixiApp);

    this._mediaById = {};
    updatedMedia.forEach((item) => {
      if (item) {
        this._mediaById[item.id] = item;
      }
    });

    return this.media;
  }

  _createOrUpdate(mediaModels, pixiApp) {
    return Promise.all(
      mediaModels.map((model) => {
        if (!this._mediaById[model.id]) {
          return MediaItem.createFromModel(model, pixiApp).catch((error) => {
            logger.info('Unable to create media from model', {
              error,
              model,
            });
            return null;
          });
        }
        if (!deepEqual(this._mediaById[model.id].model, model)) {
          this._mediaById[model.id].updateModel(model);
        }
        return this._mediaById[model.id];
      })
    );
  }

  _cleanUp(idsToKeep) {
    this.media.forEach((item) => {
      if (!idsToKeep.includes(item.id)) {
        item.destroy();
      }
    });
  }

  /**
   * Destroy stored media items
   *
   * MediaManager instance can be reused after media items are destroyed
   */
  clear() {
    this.media.forEach((media) => media.destroy());
    this._mediaById = {};
  }
}
